import React from 'react';

import columns from './columns';
import Modal from '../../../../../../components/Modal';
import Table from '../../../../../../components/table/Table';
import './AccountUserDetailLikeBrandLogModal.scss';

const AccountUserDetailLikeBrandLogModalView = (props) => {
  const { isOpen = true, likeBrandLogList, filterOption, sortOption, pagination, closeModal, getList } = props;
  const { logList, totalCnt } = likeBrandLogList;
  return (
    <Modal
      title="유저 브랜드 좋아요 타임라인 리스트"
      wrapClassName="account-user-detail-like-brand-timeline-modal"
      isOpen={isOpen}
      width={1000}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <Table
        data={logList}
        totalCnt={totalCnt}
        isStriped={true}
        scroll={{ x: true }}
        emptyText="요청하신 검색 필터로 검색된 좋아요한 브랜드 타임라인 리스트가 없습니다."
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        columns={(utils) => columns(utils)}
      />
    </Modal>
  );
};

export default AccountUserDetailLikeBrandLogModalView;
